import { flushSync } from 'react-dom';

// Runs `update` (a state change that re-renders the page) inside the browser's
// View Transitions API when available, so the change animates instead of
// snapping. `kind` ('theme' | 'route') adds a class to <html> for the duration
// so CSS can pick the right animation. Browsers without the API, and visitors
// who prefer reduced motion, just get the plain, instant update.
export function withViewTransition(update, kind = 'route', origin) {
    const canAnimate = typeof document !== 'undefined'
        && typeof document.startViewTransition === 'function'
        && typeof window.matchMedia === 'function'
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!canAnimate) {
        update();
        return;
    }

    const root = document.documentElement;
    if (origin) {
        root.style.setProperty('--vt-x', `${origin.x}px`);
        root.style.setProperty('--vt-y', `${origin.y}px`);
    }
    root.classList.add(`vt-${kind}`);

    const transition = document.startViewTransition(() => {
        flushSync(update);
    });
    const cleanup = () => root.classList.remove(`vt-${kind}`);
    transition.finished.then(cleanup, cleanup);
}
